import React, { useState } from "react";
import { ChangePasswordPrivate } from "../../api/Api";
import { getFromLocalStorage, setToLocalStorage } from "../../utils/common-utils";
import Swal from "sweetalert2";
import "./changePassword.css";

const ChangePassword = ({ onClose, isFirstLogin = false }) => {
  const userData = getFromLocalStorage("userData");
  const [error, setError] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [loader, setLoader] = useState(false);
  const [resetPassword, setResetPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = resetPassword;

    if (!newPassword || (newPassword && !pass.test(newPassword)) || 
        !confirmPassword || newPassword !== confirmPassword) {
      setError(true);
      return;
    }

    setError(false);
    setLoader(true);

    try {
      const payload = {
        userId: userData?.id,
        updateId: userData?.id,
        oldPassword: null,
        newPassword: newPassword,
      };

      const response = await ChangePasswordPrivate(payload);
      
      if (response?.statusDescription?.status === 200) {
        if (onClose) onClose();
        setResetPassword({
          newPassword: "",
          confirmPassword: "",
        });

        // Show success message and then redirect
        Swal.fire({
          title: 'Success',
          text: response?.statusDescription?.description || 'Password has been changed successfully!',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          setToLocalStorage("userData", userData?.firstLogin==false ? {
            ...userData,
            firstLogin: true
          } : userData);
          // Clear all localStorage data
          // localStorage.clear();
          // Redirect to login page
          // window.location.href = '/';
        });
      } else {
        throw new Error(response?.statusDescription?.description || 'Failed to change password');
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error.message || 'Failed to change password',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <form onSubmit={handleChangePasswordSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <div className="form-group">
            <label className="font-weight-bold">New Password</label>
            <div className="input-group">
              <input
                type={showPassword1 ? "text" : "password"}
                className={`form-control ${
                  error &&
                  (!resetPassword.newPassword ||
                    !pass.test(resetPassword.newPassword))
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="New Password"
                value={resetPassword.newPassword}
                onChange={(e) =>
                  setResetPassword((prev) => ({
                    ...prev,
                    newPassword: e.target.value,
                  }))
                }
              />
              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword1(!showPassword1)}
              >
                <i className={`fa fa-${!showPassword1 ? "eye-slash" : "eye"}`}></i>
              </span>
            </div>
            {error &&
              (!resetPassword.newPassword ||
                !pass.test(resetPassword.newPassword)) && (
                <div className="invalid-feedback d-block">
                  {!resetPassword.newPassword
                    ? "Please enter a new password"
                    : "Password must have at least 8 characters including lowercase, uppercase, number, and special character"}
                </div>
              )}
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label className="font-weight-bold">Confirm New Password</label>
            <div className="input-group">
              <input
                type={showPassword2 ? "text" : "password"}
                className={`form-control ${
                  error && !resetPassword.confirmPassword ? "is-invalid" : ""
                }`}
                placeholder="Confirm Password"
                value={resetPassword.confirmPassword}
                onChange={(e) =>
                  setResetPassword((prev) => ({
                    ...prev,
                    confirmPassword: e.target.value,
                  }))
                }
              />
              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword2(!showPassword2)}
              >
                <i className={`fa fa-${!showPassword2 ? "eye-slash" : "eye"}`}></i>
              </span>
            </div>
            {error &&
              (!resetPassword.confirmPassword ||
                resetPassword.confirmPassword !== resetPassword.newPassword) && (
                <div className="invalid-feedback d-block">
                  {!resetPassword.confirmPassword
                    ? "Please confirm your new password"
                    : "Passwords do not match"}
                </div>
              )}
          </div>
        </div>
      </div>
      <span className="password-title">Password must have:</span>
      <ul className="password-requirements">
        <li>At least 8 characters</li>
        <li>1 lowercase character</li>
        <li>1 uppercase character</li>
        <li>1 number</li>
        <li>1 special character</li>
      </ul>
      <div className="modal-footer pb-0 border-0 justify-content-end px-0 mx-0">
        <button
          type="submit"
          className="btn btn-primary btn-raised m-0"
          disabled={loader}
        >
          Submit {loader && <i className="fa fa-spinner fa-spin"></i>}
        </button>
      </div>
    </form>
  );
};

export default ChangePassword;